import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5 12.875a.376.376 0 0 1-.375-.375v-9c0-.206.169-.375.375-.375h3.75V5c0 .415.335.75.75.75h1.875v6.75a.376.376 0 0 1-.375.375zM5 2c-.827 0-1.5.673-1.5 1.5v9c0 .827.673 1.5 1.5 1.5h6c.827 0 1.5-.673 1.5-1.5V5.621a1.5 1.5 0 0 0-.438-1.062L9.938 2.44A1.5 1.5 0 0 0 8.878 2zm1.313 6a.56.56 0 0 0-.563.563c0 .311.25.562.563.562h3.375a.561.561 0 1 0 0-1.125zm0 2.25a.56.56 0 0 0-.563.563c0 .311.25.562.563.562h3.375a.561.561 0 1 0 0-1.125z"
    }, null, -1)
  ]))]))
}
export default { render: render }